import type { ResultStatus } from '@dispatch/shared/types';

/**
 * Keep-last-good UI net for bootstrap queries (['user'], ['user-permissions']).
 *
 * A transient background refetch failure AFTER a query has already returned
 * data must not blank the whole app behind BootstrapError. When the raw status
 * is 'error' but we still hold previously-fetched data, report 'success' so the
 * screen stays usable. A true first-load failure (no data ever returned, ADO
 * #101210) keeps its 'error' status and surfaces BootstrapError unchanged.
 *
 * Only 'error' is special-cased. Any other status ('success', 'loading', and
 * the 'empty'/'noresult' values mapQueryToStatus can also emit) passes through
 * unchanged — 'empty'/'noresult' are unreachable for these two object-shaped
 * bootstrap queries, but are forwarded rather than swallowed for safety.
 *
 * @param rawStatus The status computed from the underlying query.
 * @param hasData Whether the query currently holds data (a prior success).
 * @returns The status the bootstrap UI should observe.
 */
export function resolveBootstrapStatus(
  rawStatus: ResultStatus,
  hasData: boolean
): ResultStatus {
  return rawStatus === 'error' && hasData ? 'success' : rawStatus;
}
